
import Vue from 'vue';
import ArrowLeft from '@/assets/svg/icons/arrow-left-gallery.svg';
import ArrowRight from '@/assets/svg/icons/arrow-right-gallery.svg';
import Minus from '@/assets/svg/icons/minus.svg';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { TransformedCmGallery } from '~/transforms/transformModules';

export default Vue.extend({
  components: { ArrowLeft, ArrowRight, Minus },
  props: {
    data: {
      type: Object as () => TransformedCmGallery['data'],
      required: true,
    },
  },
  data() {
    return {
      heroItems: 1 as number,
      galleryItems: 0 as number,
      slider: {
        currentIndex: 0,
        touchStartPosition: 0,
        isOpen: false,
      },
    };
  },
  methods: {
    showGallery(index: number) {
      if (!this.slider.isOpen) {
        const galleryElement = this.$refs.gallery as HTMLElement;
        galleryElement.classList.add('slider');
        galleryElement.scrollIntoView();
        disableBodyScroll(galleryElement, {
          reserveScrollBarGap: true,
        });
        this.slider.isOpen = true;
        this.showImage(index);
      }
    },
    showImage(index: number) {
      this.slider.currentIndex = index;
    },
    hideGallery() {
      const galleryElement = this.$refs.gallery as HTMLElement;
      galleryElement.classList.remove('slider');
      this.slider.isOpen = false;
      this.slider.currentIndex = 0;
      galleryElement.scrollIntoView();
      clearAllBodyScrollLocks();
    },
    next() {
      this.slider.currentIndex =
        this.galleryItems + this.heroItems > this.slider.currentIndex ? this.slider.currentIndex + 1 : 1;
    },
    prev() {
      this.slider.currentIndex =
        this.slider.currentIndex > 1 ? this.slider.currentIndex - 1 : this.galleryItems + this.heroItems;
    },
  },
  mounted() {
    if (this.data.subImage) {
      this.heroItems = this.heroItems + 1;
    }
    if (this.data.gallery) {
      this.galleryItems = this.data.gallery.length;
    }
  },
});
